module.exports = "/_next/static/images/size_charts-241a6cb8b536f082a4efbfe660cc9634.svg";